import React from "react";
import {
  Crown,
  PenTool,
  Target,
  Magnet,
  Wand2,
  Handshake,
  MessageCircle,
  Cog,
} from "lucide-react";

const OUTCOMES = [
  {
    icon: <Crown className="w-5 h-5" />,
    text: "Position your expertise more powerfully in front of premium buyers.",
  },
  {
    icon: <PenTool className="w-5 h-5" />,
    text: "Build a content strategy that is directly connected to client acquisition.",
  },
  {
    icon: <Target className="w-5 h-5" />,
    text: "Generate more qualified attention from the right kind of audience.",
  },
  {
    icon: <Magnet className="w-5 h-5" />,
    text: "Create stronger lead-generation pathways that don't rely on referrals.",
  },
  {
    icon: <Wand2 className="w-5 h-5" />,
    text: "Use AI to accelerate content creation, ideation and marketing execution.",
  },
  {
    icon: <MessageCircle className="w-5 h-5" />,
    text: "Nurture leads on autopilot across WhatsApp, email and AI without manual follow-ups.",
  },
  {
    icon: <Handshake className="w-5 h-5" />,
    text: "Reduce dependence on cold outreach and inconsistent word-of-mouth.",
  },
  {
    icon: <Cog className="w-5 h-5" />,
    text: "Build a more systematic, less founder-dependent expert business.",
  },
];

export default function Outcomes() {
  return (
    <section className="relative z-10 px-4 py-10 md:py-14">
      <div className="max-w-5xl mx-auto">
        <p className="text-center text-[#C4FF3D] uppercase tracking-[0.28em] text-[11px] md:text-xs font-bold mb-3">
          Outcomes
        </p>
        <h2 className="display-font text-center text-3xl md:text-5xl font-extrabold leading-tight mb-4">
          <span className="text-white">By The End Of The Workshop, You&apos;ll</span>{" "}
          <span className="lime-box">Understand How To:</span>
        </h2>
        <p className="text-center text-white/60 max-w-3xl mx-auto mb-12 text-sm md:text-base">
          These are learning outcomes, not guaranteed income promises. What you build with them depends on you.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {OUTCOMES.map((o, i) => (
            <div
              key={i}
              className="group flex items-start gap-3 p-5 rounded-2xl bg-[#0e1410] border border-[rgba(196,255,61,0.14)] hover:border-[rgba(196,255,61,0.4)] transition"
            >
              <div className="w-10 h-10 shrink-0 rounded-xl bg-[rgba(196,255,61,0.1)] border border-[rgba(196,255,61,0.25)] flex items-center justify-center text-[#C4FF3D] group-hover:bg-[rgba(196,255,61,0.18)] transition">
                {o.icon}
              </div>
              <p className="text-white/88 leading-relaxed pt-1.5">{o.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
